import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export const CloseIcon = CloseRoundedIcon;
